import { useState, useEffect } from 'react';
import Loader from '../../ui/Loader';
import { compressImage } from '../../helpers/compressor';
import AddProfileImage from '../../assets/icons/AddProfileImage';
import Input from '../../ui/Input';
import Info from '../../assets/icons/Info';
import { uploader } from '../../helpers/uploader';
import { toast } from 'sonner';
import { useLoadingState } from '../../hooks/useLoader';
import EditLogo from '../../assets/icons/EditLogo';
import CloseIcon from '../../assets/icons/CloseIcon';

const UploadLogoComponent = ({
    fieldName,
    errorField,
    errors,
    isUploadEnable = true,
    outerPadding = 'p-6',
    size = '670X260',
}) => {
    const [uploadPicture, setUploadPicture] = useState({
        image: null,
        imageURL: fieldName.value,
    });
    const [uploadStatus, setUploadStatus] = useState('');
    const { loading: uploading, startLoading: startUploading, stopLoading: stopUploading } = useLoadingState();

    useEffect(() => {
        // Clean up the URL when component unmounts or when image changes
        return () => {
            if (uploadPicture.imageURL) {
                URL.revokeObjectURL(uploadPicture.imageURL);
            }
        };
    }, [uploadPicture.imageURL]);

    useEffect(() => {
        // When isUploadEnable is false, directly update the field after setting the picture
        if (!isUploadEnable && uploadPicture.image) {
            fieldName.onChange(uploadPicture.image);
        }
    }, [isUploadEnable, uploadPicture.image, fieldName]);

    const handleFileChange = async (event) => {
        const file = event.target.files[0]; // Get the selected file

        if (file) {
            await uploadFile(file);
        } else {
            setUploadStatus('Please select a valid file.');
        }
    };

    const uploadFile = async (file) => {
        try {
            startUploading();
            let fileToUpload = file;
            try {
                fileToUpload = await compressImage(file);
            } catch (err) {
                console.error("Compression failed", err);
            }

            const res = await uploader(fileToUpload);

            if (res.files.length) {
                setUploadPicture({
                    image: file,
                    imageURL: res.files[0],
                });
                fieldName.onChange(res.files[0]);
                toast.success('Image is successfully uploaded.');
            } else {
                toast.error('Sorry unable to upload logo');
            }
            stopUploading();
        } catch (error) {
            console.error('Error uploading file:', error);
            setUploadStatus('File upload failed.');
        }
    };

    const handleRemoveLogo = () => {
        setUploadPicture({
            image: null,
            imageURL: null,
        });
        fieldName.onChange(null);
        toast.success('Logo removed successfully.');
    };

    return (
        <div>
            <div className={`${outerPadding} bg-grayBgNormal flex flex-col text-uploadText items-center shadow-sm rounded-md`}>
                <div className="flex w-full  flex-col text-uploadText items-center">
                    <div className="border  flex flex-col gap-2 border-borderUnderline border-dashed w-full p-6 rounded-md">
                        <div>
                            <div className="bg-grayBgNormal">
                                {uploading ? (
                                    <div className="flex flex-col gap-2 items-center justify-center p-4">
                                        <Loader />
                                        <p className="text-sm font-medium animate-pulse">Compressing & Uploading...</p>
                                    </div>
                                ) : !uploadPicture.imageURL ? (
                                    <>
                                        <label className="flex flex-col gap-2 items-center" htmlFor="avatar">
                                            <AddProfileImage />
                                            <p className='text-textSecondary'>Click to choose files</p>
                                        </label>
                                        <Input id="avatar" type="file" onChange={handleFileChange} />
                                    </>
                                ) : (
                                    <div className="relative bg-grayBgNormal ">
                                        <img
                                            className="w-20 h-20 rounded-md object-center object-cover"
                                            src={uploadPicture.imageURL}
                                            alt="profile"
                                        />

                                        <div className="absolute top-0 right-0 flex gap-1 items-center">
                                            <div className="flex gap-1 items-center">
                                                <div
                                                    onClick={handleRemoveLogo}
                                                    className=" cursor-pointer rounded-full bg-grayBgNormal border border-borderUnderline flex items-center justify-center"
                                                >
                                                    <CloseIcon color="#969696" />
                                                </div>
                                                <div className="w-10 h-10 flex items-center justify-center bg-grayBgNormal border border-borderUnderline rounded-full">
                                                    <label
                                                        htmlFor="avatar"
                                                        className="cursor-pointer flex items-center justify-center w-full h-full"
                                                    >
                                                        <EditLogo />
                                                        <Input
                                                            id="avatar"
                                                            type="file"
                                                            onChange={handleFileChange}
                                                            className="hidden"
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {!uploadPicture.imageURL && (
                            <div className="flex gap-2 justify-center items-center">
                                <Info />
                                <p className="font-semibold">Max Ideal file size: 9.5 MB; Ideal dimensions: {size} px</p>
                            </div>
                        )}
                    </div>
                </div>

                {errors[errorField]?.message && <p className="text-foundryRed mt-1">{errors[errorField]?.message}</p>}
            </div>
        </div>
    );
};

export default UploadLogoComponent;
